// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3iqxI","filesListContainer":"PosDisputesFiles_filesListContainer__2IpBr","filesButton":"PosDisputesFiles_filesButton__2g7EX"};